module.exports = __webpack_public_path__ + "DS-Digital.e3debd6b1458c1763139.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/DS-Digital.eot
// module id = ../../../../../src/assets/fonts/DS-Digital.eot
// module chunks = styles